import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Observable, Subject } from 'rxjs';
import { Logger } from '../logger/logger.service';
import { MatDialog } from '@angular/material/dialog';
import { AgreeTermsPopupComponent } from 'src/app/shared/components/agree-terms-popup/agree-terms-popup.component';
import { IListPayload } from 'src/app/models/response-model';
import { OkPopupComponent } from 'src/app/shared/components/ok-popup/ok-popup.component';
import { IConfirmPopup } from 'src/app/models/confirm-popup';
import { ConfirmPopupComponent } from 'src/app/shared/components/confirm-popup/confirm-popup.component';
import { ContentPopupComponent } from 'src/app/shared/components/content-popup/content-popup.component';

const logger = new Logger('UtilService');

@Injectable({
  providedIn: 'root'
})
export class UtilService {
  private spinnerSubject = new Subject();
  public spinnerState = <Observable<boolean>>this.spinnerSubject;

  private dashboardSpinnerSubject = new Subject();
  public dashboardSpinnerState = <Observable<boolean>>this.dashboardSpinnerSubject;

  private dashboardMetricSpinnerSubject = new Subject();
  public dashboardMetricSpinnerState = <Observable<boolean>>this.dashboardMetricSpinnerSubject;

  private spinnerSubjectv2 = new Subject();
  public spinnerStatev2 = <Observable<boolean>>this.spinnerSubjectv2;

  private myProfileSubject = new Subject();
  public currentUserProfileState = <Observable<any>>this.myProfileSubject;

  public spinnerShowCount: number = 0;

  public dashboardSpinnerShowCount: number = 0;

  public dashboardMetricSpinnerShowCount: number = 0;

  public spinnerShowCountv2: number = 0;
  
  constructor(private _snackBar: MatSnackBar, public dialog: MatDialog) { }

  public spinnerShow() {
    this.spinnerShowCount++;
    this.spinnerSubject.next(true);
  }

  public dashboardSpinnerShow() {
    this.dashboardSpinnerShowCount++;
    this.dashboardSpinnerSubject.next(true);
  }

  public dashboardMetricSpinnerShow() {
    this.dashboardMetricSpinnerShowCount++;
    this.dashboardMetricSpinnerSubject.next(true);
  }

  public spinnerShowv2() {
    this.spinnerShowCountv2++;
    this.spinnerSubjectv2.next(true);
  }

  public spinnerHide() {
    this.spinnerShowCount--;
    this.spinnerShowCount = this.spinnerShowCount === -1? 0: this.spinnerShowCount;
    this.spinnerSubject.next(false);
  }

  public dashboardSpinnerHide() {
    this.dashboardSpinnerShowCount--;
    this.dashboardSpinnerShowCount = this.dashboardSpinnerShowCount === -1 ? 0 : this.dashboardSpinnerShowCount;
    this.dashboardSpinnerSubject.next(false);
  }

  public dashboardMetricSpinnerHide() {
    this.dashboardMetricSpinnerShowCount--;
    this.dashboardMetricSpinnerShowCount = this.dashboardMetricSpinnerShowCount === -1 ? 0 : this.dashboardMetricSpinnerShowCount;
    this.dashboardMetricSpinnerSubject.next(false);
  }

  public currentProfileChange() {
    this.myProfileSubject.next(false);
  }

  public spinnerHidev2() {
    this.spinnerShowCountv2--;
    this.spinnerShowCountv2 = this.spinnerShowCountv2 === -1? 0: this.spinnerShowCountv2;
    this.spinnerSubjectv2.next(false);
  }

  public spinnerCountZero(){
    this.spinnerShowCount = 0;
    this.spinnerSubject.next(false);
  }

  public onSucessToast(msg?: string): void {
    this._snackBar.open(msg ? msg : "Operation Successfull", "x", {
      duration: 5000,
      horizontalPosition: "center",
      verticalPosition: "bottom",
      panelClass: "success-snackbar",
    });
  }
  public onWarningToast(msg?: string): void {
    this._snackBar.open(msg ? msg : "Operation Successfull", "x", {
      duration: 5000,
      horizontalPosition: "center",
      verticalPosition: "bottom",
      panelClass: "warning-snackbar",
    });
  }
  public onFailureToast(msg?: string): void {
    this._snackBar.open(msg ? msg : "Operation Failed", "x", {
      horizontalPosition: "center",
      verticalPosition: "bottom",
      panelClass: "failure-snackbar",
    });
  }

  public closeToast():void{
    this._snackBar.dismiss();
  }

  public onDownloadFile(response: Blob, filename: string, blobType: string ) : void{
      const binaryData = [];
      binaryData.push(response);
      const downloadLink = document.createElement("a");
      downloadLink.href = window.URL.createObjectURL(
        new Blob(binaryData, {
          type: blobType,
        })
      );
      downloadLink.setAttribute(
        "download",
        filename
      );
      document.body.appendChild(downloadLink);
      downloadLink.click();
  }

  public httpErrorHandling(err : any, msg409?: string) {
        if(err.status === 409){
          if(msg409 == undefined){
            msg409 = err.error.message;
          }
          this.onFailureToast(
            msg409
          );
        }
        else if (err.status != 401) {
          this.onFailureToast(
            err.error ? err.error?.message : err.message
          );
        }

        this.spinnerHide();
  }

  public httpErrorHandling2(err : any, msg409?: string) {
    if(err.status === 409){
      if(msg409 == undefined){
        msg409 = err.error.message;
      }
      this.onFailureToast(
        msg409
      );
    }
    else if (err.status != 401) {
      this.onFailureToast(
        err.error ? err.error?.message : err.message
      );
    }

    this.spinnerHidev2()
}

   public openAgreeTermPopup(content: string) {
    return this.dialog.open(AgreeTermsPopupComponent, {
      maxWidth: '70vw',
      disableClose: true,
      data: {
        content: content,
      },
    });
   }

   public getStartAndEndIndexValue(totalLength: number, pageNumber: number, pageSize: number) {
    const tempEnd = pageNumber * pageSize;
    const endIndex = totalLength  < tempEnd ? totalLength : tempEnd;
    const startIndex = tempEnd - pageSize + 1;
    return {startIndex , endIndex};
   }

   public setUpListDetailsAsZero(listDetails:IListPayload<any>) : IListPayload<any> {
    listDetails.data = [];
    listDetails.current_page = 0;
    listDetails.from = 0;
    listDetails.to = 0;
    listDetails.total = 0;
    return listDetails;
   }

   public openOkPopup(msg: string, buttonName: string): any {
    return this.dialog.open(OkPopupComponent, {
       width: this.calculateDialogWidth(),
       disableClose: true,
      // height: "300px",
       data : {
         msg: msg,
         buttonLabel: buttonName
     } });
   }

   public openContentPopup(title: string, msg: string, buttonName: string): any {
    return this.dialog.open(ContentPopupComponent, {
      width: this.calculateDialogWidth(),
      disableClose: true,
      data: {
        title: title,
        msg: msg,
        buttonName: buttonName
      }
    })
   }

   public calculateDialogWidth() {
    let width = '40%';
  
    if (window.innerWidth < 768) {
      width = '80%';
    }
    return width;
  }
   
   public getMapObj(array: any[], key: string): Map<string, any>{
    const myMap = new Map(array.map(obj => [obj[key], obj]));
     //array.forEach(element => myMap.set(element.id, element) );
     return myMap;
   } 

   public openConfirmPopup(data: IConfirmPopup) {
    return this.dialog.open(ConfirmPopupComponent, {
       width: this.calculateDialogWidth(),
       disableClose: true,
      // height: "300px",
       data : data
      });
   } 

   clearBackBtnStatus(){
    localStorage.setItem('backBtnclicked', 'false');
  }
}
